<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;" v-if="role === 'business'">
        登録情報 - {{ detail.companyName }}
      </div>
      <div class="breadCrumbsContainer" style="display: flex;" v-if="role === 'worker'">
        登録情報 - {{ detail.workerName }}
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="putLodingFlg" style="padding: 0px 0px 30px 0px;">Now updateing...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{ errorMessage }}
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg && detail.companyId">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <!-- メールアドレス -->
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              アカウント情報
            </div>

            <div class="row">
              <p class="inputTitle editable">ログインID</p>
              <div class="rowRight">
                <input class="text large" v-model="loginId" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">メールアドレス</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.email" readonly>
              </div>
            </div>
            <button class="btn active" type="button" style="width:250px" @click="openModal(1)">メールアドレスを変更</button>
          </div>

          <!-- CCUS情報 -->
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              CCUS情報を更新
            </div>
            <!-- 事業者用CCUS登録情報 -->
            <div v-if="role === 'business'">
              <div class="row">
                <p class="inputTitle editable">CCUS 事業者ID</p>
                <div class="rowRight">
                  <input class="text large" v-model="detail.ccusId" readonly>
                </div>
              </div>
            </div>
            <!-- 技能者用CCUS登録情報 -->
            <div v-if="role === 'worker'">
              <div class="row">
                <p class="inputTitle editable">CCUS 技能者ID</p>
                <div class="rowRight">
                  <input class="text large" v-model="detail.ccusId" readonly>
                </div>
              </div>
              <div class="row">
                <p class="inputTitle editable">CCUS 本人確認番号</p>
                <div class="rowRight">
                  <input class="text large" v-model="detail.ccusSecurityCode" readonly>
                </div>
              </div>
            </div>
            <button class="btn active" type="button" style="width:250px" @click="openModal(2)">CCUS情報を変更</button>
          </div>

          <!-- 事業者用事業者情報 -->
          <div class="group" v-if="role === 'business'">
            <div class="groupTitle" style="display: flex;">
              事業者情報
            </div>
            <div class="row">
              <p class="inputTitle editable">事業者名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.companyName" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">代表者名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.responsibleName" readonly>
              </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">建設許可番号</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.constructionNo" readonly>
              </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">郵便番号</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.postalCode" readonly>
              </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">ご住所</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.fullAddress" readonly>
              </div>
            </div>
            <button class="btn active" type="button" style="width:250px" @click="openModal(3)">事業者情報を変更</button>
          </div>

          <!-- 技能者所属事業者情報 -->
          <div class="group" v-if="role === 'worker'">
            <div class="groupTitle" style="display: flex;">
              所属事業者
            </div>
            <div class="row">
              <p class="inputTitle editable">事業者名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.companyName" readonly>
              </div>
            </div>
          </div>

          <!-- 管理者情報 -->
          <div class="group" v-if="role === 'business'">
            <div class="groupTitle" style="display: flex;">
              管理者
            </div>
            <div class="row">
              <p class="inputTitle editable">部署・役職</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.personDivisionPosition" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">管理者名</p>
              <div class="rowRight">
                <input class="text large" v-model="detail.personFullName" readonly>
              </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">電話番号</p>
              <validation-provider name="電話番号" rules="required|min:10|max:14|numeric" mode="lazy">
                <div class="rowRight">
                  <input class="text large" v-model="detail.personTel" readonly>
                </div>
              </validation-provider>
            </div>
            <button class="btn active" type="button" style="width:250px" @click="openModal(4)">管理者情報を変更</button>
          </div>

          <!-- 技能者情報 -->
          <div class="group" v-if="role === 'worker'">
            <div class="groupTitle" style="display: flex;">
              技能者情報
            </div>
            <div class="row">
              <div class="col">
                <div class="row">
                  <p class="inputTitle editable">氏名</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.workerName" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">性別</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.genderName" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">郵便番号</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.postalCode" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">住所</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.fullAddress" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">電話番号</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.workerTel" readonly>
                  </div>
                </div>
                <button class="btn active" type="button" style="width:250px" @click="openModal(5)">プロフィールを変更</button>
              </div>
            </div>
          </div>

            <!-- 保険加入情報 -->
            <div class="group" v-if="role === 'worker'">
              <div class="groupTitle" style="display: flex;">
                保険加入情報
              </div>
              <div class="row">
                <div class="col-sm">
                  <div class="row">
                    <p class="inputTitle editable" style="width: 100px;">健康保険</p>
                    <div class="rowDouble">
                      <input class="text double" v-model="healthIns" readonly>
                    </div>
                  </div>
                  <div class="row">
                    <p class="inputTitle editable" style="width: 100px;">年金保険</p>
                    <div class="rowDouble">
                      <input class="text double" v-model="pensionIns" readonly>
                    </div>
                  </div>
                  <div class="row">
                    <p class="inputTitle editable" style="width: 100px;">雇用保険</p>
                    <div class="rowDouble">
                      <input class="text double" v-model="employmentIns" readonly>
                    </div>
                  </div>
                </div>
                <div class="col-sm">
                  <div class="row">
                    <p class="inputTitle editable" style="width: 200px;">建設業退職金共済</p>
                    <div class="rowDouble">
                      <input class="text double" v-model="kentaikyo" readonly>
                    </div>
                  </div>
                  <div class="row">
                    <p class="inputTitle editable" style="width: 200px;">中小企業退職金共済</p>
                    <div class="rowDouble">
                      <input class="text double" v-model="chutaikyo" readonly>
                    </div>
                  </div>
                  <div class="row">
                    <p class="inputTitle editable" style="width: 200px;">労災保険</p>
                    <div class="rowDouble">
                      <input class="text double" v-model="workmansCompIns" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          <!-- 保有資格情報 -->
          <div class="group" v-if="role === 'worker'">
            <div class="groupTitle" style="display: flex;">
              保有資格情報
            </div>
            <div class="row">
              <div v-if="licenses.length > 0">
                <ul>
                  <li v-for="qualification in licenses" :key="qualification.id"
                    style="text-align: left; font-size: 1.25rem">
                    {{ qualification.licenseName }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>

    <!-- メールアドレス更新モーダル画面 -->
    <Modal size="email" @close="closeModal(1)" v-if="loginIdModal">
      <p class="modalTitle">メールアドレス更新</p>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div style="padding-left:40px;">
            <div class="inputTitle" style="display: flex;">
              現在のメールアドレス
            </div>
            <div class="row">
              <div class="rowRight">
                <input class="text large" v-model="detail.email" readonly>
              </div>
            </div>
            <div class="inputTitle" style="display: flex;">
              メールアドレス
            </div>
            <div class="row">
              <validation-provider name="メールアドレス" rules="required|emailVaridate|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.email" :placeholder="detail.email">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
          <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
            <p>
              入力したメールアドレス宛に確認メールが届きます。<br>
              送付されたURLにアクセスすることでメールアドレスの変更が確定されます。<br>
              必ずメール受信をご確認下さい。<br>
              メール受信制限をされている方は ep-manager.com からのメール受信を許可してください。
            </p>
          </div>
          <div class="buttonGroup" style="margin: 40px 0px;">
            <button class="btn" type="button" @click="updateEmail()" style="margin:auto;"
              v-bind:class="{ disabled: isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
              :disabled="ObserverProps.invalid">更新する
            </button>
            <button type="button" @click="closeModal(1)" class="modalNo" style="margin-right: auto;">キャンセル</button>
          </div>
        </validation-observer>
      </form>
    </Modal>

    <!-- CCUS ID更新モーダル画面 -->
    <Modal size="email" @close="closeModal(2)" v-if="ccusModal">
      <p class="modalTitle">CCUS情報を更新</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p></p>
      </div>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <!-- 事業者の場合 -->
          <div style="padding: 0px 40px;" v-if="role === 'business'">
            <div class="inputTitle" style="display: flex;">
              CCUS事業者ID
            </div>
            <div class="row">
              <validation-provider name="CCUS事業者ID" rules="required|digits:14" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.ccusId" :placeholder="detail.ccusId">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <p style="text-align: left;">CCUS登録時に発行される14桁の事業者IDです。</p>
            <div class="inputTitle" style="display: flex;">
              CCUS事業者パスワード
            </div>
            <div class="row">
              <validation-provider name="CCUS事業者パスワード" rules="required|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" type="password" v-model="newDetail.ccusPassword">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <p style="text-align: left;">CCUS登録時に発行されるAPI呼出に利用するパスワードです。</p>
          </div>

          <!-- 技能者の場合 -->
          <div style="padding: 0px 40px;" v-if="role === 'worker'">
            <div class="inputTitle" style="display: flex;">
              CCUS技能者ID
            </div>
            <div class="row">
              <validation-provider name="CCUS技能者ID" rules="required|digits:14" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.ccusId" :placeholder="detail.ccusId">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <p style="text-align: left;">CCUS登録時に発行される14桁の技能者IDです。</p>
            <div class="inputTitle" style="display: flex;">
              CCUS技能者本人確認番号
            </div>
            <div class="row">
              <validation-provider name="CCUS技能者本人確認番号" rules="required|digits:4" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.ccusSecurityCode">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <p style="text-align: left;">CCUS登録時に発行される技能者カード裏面記載の4桁の本人確認番号です。</p>
          </div>
          <div class="buttonGroup" style="margin: 40px 0px;">
            <button class="btn" type="button" @click="updateCcusId()" style="margin:auto;"
              v-bind:class="{ disabled: isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
              :disabled="ObserverProps.invalid">更新する
            </button>
            <button type="button" @click="closeModal(2)" class="modalNo" style="margin-right: auto;">キャンセル</button>
          </div>
        </validation-observer>
      </form>
    </Modal>

    <!-- 事業者情報更新モーダル画面 -->
    <Modal size="email" @close="closeModal(3)" v-if="companyModal">
      <p class="modalTitle">事業者情報更新</p>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div style="padding: 0px 40px;">
            <div class="inputTitle" style="display: flex;">
              事業者名
            </div>
            <div class="row">
              <validation-provider name="事業者名" rules="required|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.companyName" :placeholder="detail.companyName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              代表者名
            </div>
            <div class="row">
              <validation-provider name="代表者名" rules="alpha|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.responsibleName" :placeholder="detail.responsibleName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              建設許可番号
            </div>
            <div class="row">
              <validation-provider name="建設許可番号" rules="max:16" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.constructionNo" :placeholder="detail.constructionNo">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              郵便番号
            </div>
            <div class="row">
              <validation-provider name="郵便番号" rules="required|digits:7|addressFlg" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" @change="getAddress(newDetail.postalCode)" class="text large" name="postalCode"
                    v-model="newDetail.postalCode" placeholder="例：1000001 ハイフン無し半角数字のみ入力">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan" v-if="postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                    <span class="prefectureErrSpan" v-if="!postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              都道府県
            </div>
            <div class="row">
              <validation-provider name="都道府県" rules="required||max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.prefecture" :placeholder="'例：東京都'" >
                    <div class="errMsg" v-if="ProviderProps.errors[0]">
                      <span class="errSpan">
                        {{ ProviderProps.errors[0] }}
                      </span>
                    </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              市区町村
            </div>
            <div class="row">
              <validation-provider name="市区町村" rules="required||max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" class="text large" name="city" v-model="newDetail.city"
                  :placeholder="'例：千代田区'" />
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              町・番地
            </div>
            <div class="row">
              <div class="rowRight">
                <input class="text large" v-model="newDetail.town" :placeholder="'例：丸の内1-1'">
              </div>
            </div>
            <div class="inputTitle" style="display: flex;">
              建物名・部屋番号
            </div>
            <div class="row">
              <div class="rowRight">
                <input class="text large" v-model="newDetail.otherAddress" :placeholder="'例：千代田ビル2F'">
              </div>
            </div>
          </div>
          <div class="buttonGroup" type="button" style="margin: 40px 0px;">
            <button class="btn" type="button" @click="updateCompany" style="margin:auto;"
              v-bind:class="{ disabled: isProcessing() || !ObserverProps.validate 
              ||!isPostDisabled(ObserverProps,postalHasError)
              || newDetail.companyName === ''
              || newDetail.prefecture === ''
              || newDetail.city === '', 
              active: isPostDisabled(ObserverProps,postalHasError)
              && newDetail.companyName !== ''
              && newDetail.prefecture !== ''
              && newDetail.city !== ''
              && ObserverProps.validate }"
              :disabled="!isPostDisabled(ObserverProps,postalHasError)
              || newDetail.companyName === ''
              || newDetail.prefecture === ''
              || newDetail.city === ''">更新する
            </button>
            <button type="button" @click="closeModal(3)" class="modalNo" style="margin-right: auto;">キャンセル</button>
          </div>
        </validation-observer>
      </form>
    </Modal>

    <!-- 事業者管理者情報更新モーダル画面 -->
    <Modal size="email" @close="closeModal(4)" v-if="managerModal">
      <p class="modalTitle">管理者情報更新</p>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div style="padding: 0px 40px;">
            <div class="inputTitle" style="display: flex;">
              部署【任意】
            </div>
            <div class="row">
              <validation-provider name="部署" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.personDivision" :placeholder="detail.personDivision">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              役職【任意】
            </div>
            <div class="row">
              <validation-provider name="役職" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.personPosition" :placeholder="detail.personPosition">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              姓
            </div>
            <div class="row">
              <validation-provider name="姓" rules="alpha|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.personLastName" :placeholder="detail.personLastName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              名
            </div>
            <div class="row">
              <validation-provider name="名" rules="alpha|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.personFirstName" :placeholder="detail.personFirstName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              電話番号
            </div>
            <div class="row">
              <validation-provider name="電話番号" rules="min:10|max:14|numeric" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.personTel" :placeholder="detail.personTel">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="buttonGroup" style="margin: 40px 0px;">
            <button class="btn" type="button" @click="managerUpdate" style="margin:auto;"
              v-bind:class="{ disabled: isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
              :disabled="ObserverProps.invalid">更新する
            </button>
            <button type="button" @click="closeModal(4)" class="modalNo" style="margin-right: auto;">キャンセル</button>
          </div>
        </validation-observer>
      </form>
    </Modal>

    <!-- 技能者情報更新モーダル画面 -->
    <Modal size="email" @close="closeModal(5)" v-if="workerModal">
      <p class="modalTitle">技能者情報更新</p>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div style="padding: 0px 40px;">
            <div class="inputTitle" style="display: flex;">
              姓
            </div>
            <div class="row">
              <validation-provider name="姓" rules="required|max:64|valid_characters" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.workerLastName" :placeholder="detail.workerLastName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              名
            </div>
            <div class="row">
              <validation-provider name="名" rules="required|max:64|valid_characters" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.workerFirstName" :placeholder="detail.workerFirstName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              性別
            </div>
            <div class="row">
              <validation-provider name="性別">
                <div class="rowRight" slot-scope="genderProps">
                  <div class="selectdiv">
                    <select v-model="newDetail.genderId">
                      <option value="" selected>性別</option>
                      <option v-for="gender in optionGender" v-bind:value="gender.id">
                        {{ gender.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              郵便番号
            </div>
            <div class="row">
              <validation-provider name="郵便番号" rules="digits:7|addressFlg" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" @change="getAddress(newDetail.postalCode)" class="text large" placeholder="例：1000001 ハイフン無し半角数字のみ入力"
                    v-model="newDetail.postalCode">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      <span class="errSpan" v-if="postalHasError">
                        {{ ProviderProps.errors[0] }}
                      </span>
                      <span class="prefectureErrSpan" v-if="!postalHasError">
                        {{ ProviderProps.errors[0] }}
                      </span>
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              都道府県
            </div>
            <div class="row">
              <validation-provider name="都道府県" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.prefecture" :placeholder="'例：東京都'">
                    <div class="errMsg" v-if="ProviderProps.errors[0]">
                      <span class="errSpan" >
                        {{ ProviderProps.errors[0] }}
                      </span>
                    </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              市区町村
            </div>
            <div class="row">
              <validation-provider name="市区町村" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" class="text large" name="city" v-model="newDetail.city"
                  :placeholder="'例：千代田区'" />
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              町・番地
            </div>
            <div class="row">
              <div class="rowRight">
                <input class="text large" v-model="newDetail.town" :placeholder="'例：丸の内1-1'">
              </div>
            </div>
            <div class="inputTitle" style="display: flex;">
              建物名・部屋番号
            </div>
            <div class="row">
              <validation-provider name="建物名・部屋番号" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.otherAddress" :placeholder="'例：千代田ビル2F'">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="inputTitle" style="display: flex;">
              電話番号
            </div>
            <div class="row">
              <validation-provider name="電話番号" rules="min:10|max:14|numeric" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="newDetail.workerTel" :placeholder="detail.workerTel">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="buttonGroup" style="margin-bottom:5px">
            <button class="btn" type="button" @click="workerUpdate" style="margin:auto;"
              v-bind:class="{ disabled: isProcessing() || !ObserverProps.validate 
              ||!isWkPostDisabled(ObserverProps,postalHasError)
              || newDetail.workerLastName === ''
              || newDetail.workerFirstName === '',
              active: isWkPostDisabled(ObserverProps,postalHasError)
              && newDetail.workerLastName !== ''
              && newDetail.workerFirstName !== ''
              && ObserverProps.validate }"
              :disabled="!isWkPostDisabled(ObserverProps,postalHasError)
              || newDetail.workerLastName === ''
              || newDetail.workerFirstName === ''">更新する
            </button>
            <button type="button" @click="closeModal(5)" class="modalNo" style="margin-right: auto;">キャンセル</button>
          </div>
        </validation-observer>
      </form>
    </Modal>

  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';
import Modal from './BaseModal.vue';

// when使用のための処理 ------ start
type ChainedWhen<T, R> = {
  on: <A>(pred: (v: T) => boolean, fn: () => A) => ChainedWhen<T, R | A>;
  otherwise: <A>(fn: () => A) => R | A;
};

const match = <T, R>(val: any): ChainedWhen<T, R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) => match<T, R | A>(val),
  otherwise: <A>(fn: () => A): A | R => val,
});

const chain = <T, R>(val: T): ChainedWhen<T, R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match(fn()) : chain<T, A | R>(val),
  otherwise: <A>(fn: () => A) => fn(),
});

const when = <T>(val: T) => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match<T, A>(fn()) : chain<T, A>(val),
});
// when使用のための処理 ------ end

export default {
  title: '会員情報',
  name: 'Account',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
    Modal,
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      loginId: '',
      companyId: '',
      workerId: '',
      today: 0,
      detail: {
        ccusId: '',
        ccusPassword: '',
        ccusSecurityCode: '',
        companyName: '',
        companyId: '',
        responsibleName: '',
        constructionNo: '',
        personDivision: '',
        personPosition: '',
        personDivisionPosition: '',
        personFullName: '',
        personLastName: '',
        personFirstName: '',
        genderId: '',
        personTel: '',
        approve: true,
        updatedAt: '',

        // 作業者情報
        name: '',
        gender: '',
        postalCode: '',
        fullAddress: '',
        tel: '',
        email: '',
      },
      newDetail: {
        ccusId: '',
        ccusPassword: '',
        ccusSecurityCode: '',
        companyName: '',
        companyId: '',
        responsibleName: '',
        constructionNo: '',
        prefecture: '',
        city: '',
        town: '',
        otherAddress: '',
        personDivision: '',
        personPosition: '',
        personDivisionPosition: '',
        personFullName: '',
        personLastName: '',
        personFirstName: '',
        genderId: '', 
        personTel: '',
        approve: true,
        updatedAt: '',

        // 作業者情報
        name: '',
        gender: '',
        postalCode: '',
        fullAddress: '',
        tel: '',
        email: '',
      },
      healthIns: '未加入',       // 健康保険
      pensionIns: '未加入',      // 年金保険
      employmentIns : '未加入',  // 雇用保険
      kentaikyo: '未加入',       // 建退共
      chutaikyo: '未加入',       // 中退共
      workmansCompIns: '未加入',    // 労災保険

      // 保険加入情報
      insurance: {
        health: false,               // 健康保険
        pension: true,               // 年金保険
        employment: false,           // 雇用保険
        kentai: false,              // 建退共
        tyutai: false,              // 中退共
        industrialAccident: false,  // 労災保険
        healthInsStatus: 0,       // 健康保険
        pensionInsStatus: 0,      // 年金保険
        employmentInsStatus : 0,  // 雇用保険
        kentaikyoStatus: 0,       // 建退共
        chutaikyoStatus: 0,       // 中退共
        workmansCompInsStatus: 0,    // 労災保険
      },
      // 保有資格を配列で取得？
      licenses: [],
      // ドロップダウンリスト
      // 選択用性別配列
      optionGender: [
        {
          id: 'ge3138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: '男性',
        },
        {
          id: 'ge2138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: '女性',
        },
        {
          id: 'ge1138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: 'その他',
        },
      ],
      // モーダル表示用フラグ
      loginIdModal: false,
      ccusModal: false,
      companyModal: false,
      managerModal: false,
      workerModal: false,
      // ローディング用フラグ
      getLodingFlg: true,
      getErrorFlg: false,
      putLodingFlg: false,
      putErrorFlg: false,
      processing: false,
      errorMessage: '',
      displayingModal: 0,
      // 郵便番号エラー判定用フラグ
      postalHasError:true,
    };
  },
  // 初期処理
  async mounted() {
    // セッション情報からログイン事業者IDを取得
    const session = this.$store.getters.session;
    this.loginId = session.loginId;
    this.companyId = session.companyId;
    if (this.role === 'worker') {
      this.workerId = session.workerId;
      // 技能者保険加入情報取得
      await this.getInsurances();
      // 技能者保有資格情報取得
      await this.getLicenses();
    }
    this.today = Date.now();
    try {
      // プロフィール報取得API呼出
      await this.setAccount();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // Profile取得API呼出
    async setAccount() {
      try {
        const restResourceService = new ApiClient();
        const result = await restResourceService.getAccount(this.companyId, this.workerId);
        if (this.role === 'business') {
          if (result.personLastName && result.personFirstName) {
            result.personFullName = result.personLastName + result.personFirstName;
          } else {
            result.personFullName = '';
          }
          if (result.personDivision && result.personPosition) {
            result.personDivisionPosition = result.personDivision + result.personPosition;
          } else {
            result.personDivisionPosition = '';
          }
        }
        this.detail = Object.assign({}, result);
        this.newDetail = Object.assign({}, result);
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // 郵便番号を元に住所取得 同一の処理のため、関数を作成し共通化
    async getAddress(postalCode) {
      const restResourceService = new ApiClient();
      await restResourceService.getAddress(postalCode)
        .then((res) => {
          if(res === 404){
            this.postalHasError = false;
            this.newDetail.prefecture = "";
            this.newDetail.city = "";
            this.newDetail.town = "";
          } else{
            this.postalHasError = true;
            this.newDetail.prefecture = res.pref;
            this.newDetail.city = res.city;
            this.newDetail.town = res.town;
          }
        },
        );
    },

    // 加入保険情報取得
    async getInsurances() {
    try {
    // 加入保険情報取得API呼出
      const restResourceService = new ApiClient();
      this.insurance = await restResourceService.getWorkerInsurances(this.workerId);
      this.healthIns = this.insCheck(this.insurance.healthInsStatus);
      this.pensionIns = this.insCheck(this.insurance.pensionInsStatus);
      this.employmentIns = this.insCheck(this.insurance.employmentInsStatus);
      this.kentaikyo = this.insCheck(this.insurance.kentaikyoStatus);
      this.chutaikyo = this.insCheck(this.insurance.chutaikyoStatus);
      this.workmansCompIns = this.insCheck(this.insurance.workmansCompInsStatus);
    } catch (error) {
      throw error;
    }},
    insCheck(ins) {
      switch (ins) {
        case 0:
          return '未加入';
          break;
        case 1:
          return '加入';
          break;
        case 2:
          return '適用除外';
          break;
        default:
          return '未加入';
          break;
      }
    },
    // 保有資格情報取得
    async getLicenses() {
      try {
      // 保有資格情報取得API呼出
        const restResourceService = new ApiClient();
        this.licenses = await restResourceService.getWorkerLicenses(this.workerId);
        console.log("await restResourceService.getWorkerLicenses(this.workerId)")
        console.log(await restResourceService.getWorkerLicenses(this.workerId))
        console.log("this.qualifications")
        console.log(this.licenses)
      } catch (error) {
        throw error;
      }
    },

    // モーダルを開く
    openModal(num) {
      this.displayingModal = num;
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.modalBack);
      when(num)
        .on((v) => v === 1, () => this.loginIdModal = true)   // メールアドレス更新
        .on((v) => v === 2, () => this.ccusModal = true)      // CCUS ID更新
        .on((v) => v === 3, () => this.companyModal = true)   // 事業者情報更新
        .on((v) => v === 4, () => this.managerModal = true)   // 事業者管理者更新
        .on((v) => v === 5, () => this.workerModal = true);   // 事業者管理者更新
    },
    // モーダルを閉じる
    closeModal(num) {
      window.removeEventListener('popstate', this.modalBack);
      when(num)
        .on((v) => v === 1, () => this.loginIdModal = false)  // メールアドレス更新
        .on((v) => v === 2, () => this.ccusModal = false)     // CCUS ID更新
        .on((v) => v === 3, () => this.companyModal = false)  // 事業者情報更新
        .on((v) => v === 4, () => this.managerModal = false)  // 事業者管理者更新
        .on((v) => v === 5, () => this.workerModal = false); // 事業者管理者更新
    },
    // モーダル表示中ブラウザバック処理
    modalBack() {
      this.closeModal(this.displayingModal);
    },
    // メールアドレス更新
    async updateEmail() {
      try {
        await this.startProcessing();
        const body = {
          loginId: this.loginId,
          email: this.detail.email,
          newEmail: this.newDetail.email,
          role: this.role,
        };

        this.postErrorFlg = false;
        this.postLodingFlg = true;
        // メールアドレス更新API呼び出し
        const restResourceService = new ApiClient();
        await restResourceService.patchAccountEmail(body);
        // メール送信API呼出
        // メールに使用するTemplateData
        const templateData = {
          oldEmail: this.detail.email,
          newEmail: this.newDetail.email,
        };
        await restResourceService.changeMail(this.newDetail.email, templateData);
        // 登録情報再取得
        await this.setAccount();
      } catch (error) {
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.closeModal(1);
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },

    // CCUS ID更新
    async updateCcusId() {
      try {
        await this.startProcessing();
        this.postErrorFlg = false;
        this.postLodingFlg = true;
        const restResourceService = new ApiClient();
        if (this.role === 'worker') {
          const body = {
            ccusId: this.detail.ccusId,
            newCcusId: this.newDetail.ccusId,
            ccusSecurityCode: this.newDetail.ccusSecurityCode,
            workerId: this.workerId,
            companyId: this.companyId,
          };
          // CCUS技能者ID登録API呼び出し
          await restResourceService.patchWorkerCcus(body);
        } else {
          const body = {
            ccusId: this.newDetail.ccusId,
            ccusPassword: this.newDetail.ccusPassword,
            companyId: this.companyId,
          };
          // CCUS技能者ID登録API呼び出し
          await restResourceService.patchAccountCcus(body);
        }
        // 登録情報再取得
        await this.setAccount();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.closeModal(2);
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },

    // 事業者情報更新
    async updateCompany() {
      try {
        await this.startProcessing();
        this.postErrorFlg = false;
        this.postLodingFlg = true;
        let fullAddress = common.trimSpace(this.newDetail.prefecture + this.newDetail.city + this.newDetail.town);
        if (this.newDetail.otherAddress) {
          fullAddress += this.newDetail.otherAddress;
        }

        // const role = this.role();
        const restResourceService = new ApiClient();
        const body = {
          companyName: common.trimSpace(this.newDetail.companyName),
          responsibleName: common.trimSpace(this.newDetail.responsibleName),
          constructionNo: common.trimSpace(this.newDetail.constructionNo),
          postalCode: common.trimSpace(this.newDetail.postalCode),
          fullAddress,
          prefecture: common.trimSpace(this.newDetail.prefecture),
          city: common.trimSpace(this.newDetail.city),
          town: common.trimSpace(this.newDetail.town),
          otherAddress: common.trimSpace(this.newDetail.otherAddress),
        };
        // 事業者情報更新API呼び出し
        await restResourceService.patchAccountCompany(this.companyId, body);
        // 登録情報再取得
        await this.setAccount();
        this.closeModal(3);
      } catch (error) {
        console.log(error);
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.closeModal(3);
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },

    // 事業者担当者情報更新
    async managerUpdate() {
      try {
        await this.startProcessing();
        this.postErrorFlg = false;
        this.postLodingFlg = true;
        const restResourceService = new ApiClient();
        const body = {
          personDivision: common.trimSpace(this.newDetail.personDivision),
          personPosition: common.trimSpace(this.newDetail.personPosition),
          personLastName: common.trimSpace(this.newDetail.personLastName),
          personFirstName: common.trimSpace(this.newDetail.personFirstName),
          personTel: common.trimSpace(this.newDetail.personTel),
        };
        // アカウント事業者担当者情報更新API呼び出し
        await restResourceService.patchAccountManager(this.companyId, body);
        // 登録情報再取得
        await this.setAccount();
        this.closeModal(4);
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.closeModal(4);
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },

    // 技能者情報更新
    async workerUpdate() {
      try {
        if(this.newDetail.prefecture === undefined)this.newDetail.prefecture = '';
        if(this.newDetail.city === undefined)this.newDetail.city = '';
        if(this.newDetail.town === undefined)this.newDetail.town = '';
        await this.startProcessing();
        this.postErrorFlg = false;
        this.postLodingFlg = true;
        const fullName = this.newDetail.workerLastName + this.newDetail.workerFirstName;
        const fullAddress = this.newDetail.prefecture + this.newDetail.city + this.newDetail.town + this.newDetail.otherAddress;
        const restResourceService = new ApiClient();
        const body = {
          workerName: fullName,
          workerLastName: this.newDetail.workerLastName,
          workerFirstName: this.newDetail.workerFirstName,
          postalCode: this.newDetail.postalCode,
          fullAddress,
          prefecture: this.newDetail.prefecture,
          city: this.newDetail.city,
          town: this.newDetail.town,
          otherAddress: this.newDetail.otherAddress,
          workerTel: this.newDetail.workerTel,
          genderId: this.newDetail.genderId,
        };
        // 技能者情報更新API呼び出し
        await restResourceService.patchAccountWorker(this.workerId, body);
        // 登録情報再取得
        await this.setAccount();
        this.closeModal(5);
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        this.postErrorFlg = true;
        this.endProcessing();
      } finally {
        this.closeModal(5);
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // 技術社更新ボタン活性化判定用
    isWkPostDisabled(item,isError){
      return common.isPostalValidate(item,isError,0)
    },
    // 事業者更新ボタン活性化判定用
    isPostDisabled(item,isError){
      return common.isPostalValidate(item,isError,1)
    },
    // チャタリング防止
    async startProcessing() {
      this.processing = true;
    },
    async endProcessing() {
      this.processing = false;
    },
    async isProcessing() {
      return this.processing;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

.modalTitle {
  margin: 10px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}

.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}

.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
